import { Camera, X } from "lucide-react";
import CustomInput from "../../shared/CustomInput";
import { useQuery } from "react-query";
import { getRoles } from "../../sdk/roles/roles";
import { getBranches } from "../../sdk/branch/branch";
import { useRef, useState } from "react";
import { uploadImage } from "../../sdk/upload/upload";
import Loading from "../../shared/Loading";

const EditUser = ({
  closeAddUser,
  handleCollectUserInformation,
  adminUser,
  setAdminUser,
  loading,
}) => {
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const myFile = await uploadImage(file);
      setAdminUser({ ...adminUser, profileUrl: myFile.url });
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const { data: roles } = useQuery({
    queryKey: ["roles"],
    queryFn: () => getRoles(),
  });

  const { data: branches } = useQuery({
    queryKey: ["branches"],
    queryFn: () => getBranches(),
  });

  return (
    <div
      onClick={(e) => {
        closeAddUser();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[600px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeAddUser}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] right-[20px]">
          <button
            disabled={loading}
            onClick={handleCollectUserInformation}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            {loading && <Loading />}
            Edit Details
          </button>
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">Edit User</p>
          <p className="text-[#5C5C5C] text-[15px] font-normal">
            Provide details to create a new user
          </p>
          <div className="flex items-center gap-[10px]">
            {!imagePreview && adminUser?.profileUrl?.length > 0 && (
              <div className="h-[110px] w-[110px] my-[20px] rounded-[20px] overflow-hidden cursor-pointer">
                <img
                  src={adminUser?.profileUrl}
                  alt="Uploaded preview"
                  className="h-full w-full object-cover"
                />
              </div>
            )}
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />
            {imagePreview ? (
              <div
                onClick={triggerFileInput}
                className="h-[110px] w-[110px] my-[20px] rounded-[20px] overflow-hidden cursor-pointer"
              >
                <img
                  src={imagePreview}
                  alt="Uploaded preview"
                  className="h-full w-full object-cover"
                />
              </div>
            ) : (
              <div
                onClick={triggerFileInput}
                className="h-[110px] w-[110px] flex flex-col justify-between rounded-[20px] my-[20px] bg-[#F3F3F3] cursor-pointer"
              >
                <div className="h-[60%] flex items-end py-[10px] justify-center w-full">
                  <Camera size={23} />
                </div>
                <div className="h-[40%] flex items-center justify-center rounded-b-[20px] bg-[#A8A8A8] text-center w-full">
                  <p className="text-[#F3F3F3] text-[12px] font-normal">
                    {adminUser?.profileUrl?.length > 0
                      ? "Replace profile picture"
                      : " Upload Profile Picture"}
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="firstName"
              >
                First Name
              </label>
              <CustomInput
                placeholder="Enter your first name"
                type="text"
                value={adminUser.firstName}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, firstName: e.target.value });
                }}
              />
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="lastname"
              >
                Last Name
              </label>
              <CustomInput
                placeholder="Enter your last name"
                type="text"
                value={adminUser.lastName}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, lastName: e.target.value });
                }}
              />
            </div>
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="username"
              >
                Username
              </label>
              <CustomInput
                placeholder="Enter your username"
                type="text"
                value={adminUser.username}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, username: e.target.value });
                }}
              />
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Email Address"
              >
                Email Address
              </label>
              <CustomInput
                placeholder="Enter your email address"
                type="text"
                value={adminUser.email}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, email: e.target.value });
                }}
              />
            </div>
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="phone"
              >
                Phone
              </label>
              <CustomInput
                placeholder="Enter your phone"
                value={adminUser.phoneNumber}
                type="text"
                onChange={(e) => {
                  setAdminUser({ ...adminUser, phoneNumber: e.target.value });
                }}
              />
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Branch"
              >
                Branch
              </label>
              <select
                className="h-[45px] w-full text-[14px] rounded-[5px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9] bg-white"
                name="branch"
                value={adminUser.branch}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, branch: e.target.value });
                }}
              >
                <option value="">Select a branch</option>
                {branches?.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="role"
              >
                Role
              </label>
              <select
                className="h-[45px] w-full text-[14px] rounded-[5px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9] bg-white"
                name="role"
                value={adminUser.role}
                onChange={(e) => {
                  setAdminUser({ ...adminUser, role: e.target.value });
                }}
              >
                <option value="">Select a role</option>
                {roles?.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
